import "./TripStyle.css";
import TripData from "./TripData";
import Trip1 from"../assets/3.jpg"
import Trip2 from"../assets/8.jpg"
import Trip3 from"../assets/9.jpg"
function Trip(){
    return(
        <div className="trip">
            <h1>Recent Trips</h1>
            <p>You can disciver unique destinations using Google Maps.</p>
            <div className="Tripcard">
                <TripData
                image={Trip1}
                
                heading="Trip in France"
                
                text="A trip to France offers a wide range of experiences, from exploring historic cities and charming villages to enjoying beautiful beaches and indulging in delicious cuisine. The country is known for its iconic landmarks such as the Eiffel Tower in Paris, the Palace of Versailles, and the medieval city of Lyon. France also boasts diverse landscapes, including the French Riviera, the picturesque Provence region, and the scenic countryside of the Loire Valley.                
                The best time to visit France largely depends on your preferences and the activities you plan to engage in. Spring (April to June) and fall (September to October) offer pleasant weather and fewer crowds, making them ideal for sightseeing and outdoor activities. The summer months of July and August are popular for beach vacations, but it can be crowded, especially in tourist hotspots. Winter in France, particularly in the Alps, is perfect for winter sports enthusiasts."                
                />

                <TripData
                image={Trip2}

                heading="Trip in Italy"
               
                text="Italy, located in Southern Europe, offers a diverse range of experiences for travelers. The country is known for its rich history, art, culture, delicious cuisine, and stunning landscapes.
                 Popular destinations in Italy include Rome, Florence, Venice, and the Amalfi Coast. Visitors can explore ancient ruins like the Colosseum, marvel at Renaissance masterpieces in museums, take gondola rides through picturesque canals, and indulge in authentic Italian pasta and pizza. 
                Italy also boasts beautiful coastal areas, such as the Cinque Terre and the island of Sicily, offering breathtaking views and opportunities for relaxation."                
                />
               
                <TripData
                image={Trip3}

               
                heading="Trip in Egypt"
               
                text="Egypt, located in North Africa, is a captivating destination known for its ancient civilization and iconic landmarks.
                 A trip to Egypt offers a chance to explore the majestic pyramids of Giza, including the Great Pyramid of Khufu, the Sphinx, and the Valley of the Kings in Luxor, where you can discover the tombs of pharaohs. The bustling capital city of Cairo is home to the Egyptian Museum, showcasing artifacts from ancient Egypt, as well as vibrant markets and Islamic architecture. A cruise along the Nile River provides an opportunity 
                 to witness the stunning temples of Luxor and Karnak. Egypt's Red Sea coast offers beautiful beach resorts and opportunities for snorkeling and diving in the crystal-clear waters. 
                From exploring ancient ruins to experiencing vibrant culture, Egypt offers a unique and unforgettable travel experience. "               
                 />
           
            </div>
        </div>
    );
}

export default Trip;